import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, XIcon } from 'lucide-react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { coffeeData } from '../components/coffee/coffeeData';
const CalendarPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [eventTypeFilter, setEventTypeFilter] = useState<'all' | 'online' | 'in-person'>('all');
  const monthNames = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
  const dayNames = ['L', 'M', 'M', 'G', 'V', 'S', 'D'];
  const getDaysInMonth = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1;
    return {
      daysInMonth,
      startingDayOfWeek
    };
  };
  const getEventsForDate = (date: Date) => {
    return coffeeData.filter(event => {
      const eventDate = new Date(event.date);
      const isSameDay = eventDate.toDateString() === date.toDateString();
      if (!isSameDay) return false;
      if (eventTypeFilter === 'all') return true;
      if (eventTypeFilter === 'online') return event.eventType === 'online';
      if (eventTypeFilter === 'in-person') return event.eventType === 'in-person';
      return true;
    });
  };
  const previousMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1));
  };
  const nextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1));
  };
  const {
    daysInMonth,
    startingDayOfWeek
  } = getDaysInMonth(currentDate);
  const days = Array.from({
    length: daysInMonth
  }, (_, i) => i + 1);
  const emptyDays = Array.from({
    length: startingDayOfWeek
  }, (_, i) => i);
  const selectedDateEvents = selectedDate ? getEventsForDate(selectedDate) : [];
  return <div className="flex h-screen bg-gray-50" data-id="element-2069">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-2070">
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-2071"></div>
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-2072">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-2073">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-2074">
              <span className="sr-only" data-id="element-2075">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-2076" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-2077">
            <Sidebar activePage="formazione" data-id="element-2078" />
          </div>
        </div>
      </div>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-2079">
        <Sidebar activePage="formazione" data-id="element-2080" />
      </div>

      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2081">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-2082" />

        <main className="flex-1 overflow-y-auto p-4 md:p-8 bg-gray-50" data-id="element-2083">
          <div className="max-w-7xl mx-auto" data-id="element-2084">
            {/* Header */}
            <div className="mb-6" data-id="element-2085">
              <h1 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-2086">
                Calendario
              </h1>
              <p className="text-sm text-gray-600 font-normal" data-id="element-2087">
                Visualizza tutti gli eventi della community
              </p>
            </div>

            {/* Calendar Card */}
            <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-2088">
              {/* Calendar Header */}
              <div className="p-4 md:p-6 border-b border-gray-200" data-id="element-2089">
                <div className="flex items-center justify-between mb-4" data-id="element-2090">
                  <h2 className="text-lg font-semibold text-gray-900" data-id="element-2091">
                    {monthNames[currentDate.getMonth()]}{' '}
                    {currentDate.getFullYear()}
                  </h2>
                  <div className="flex items-center gap-2" data-id="element-2092">
                    <button onClick={previousMonth} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-2093">
                      <ChevronLeftIcon size={20} className="text-gray-600" data-id="element-2094" />
                    </button>
                    <button onClick={nextMonth} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-2095">
                      <ChevronRightIcon size={20} className="text-gray-600" data-id="element-2096" />
                    </button>
                  </div>
                </div>

                {/* Filters */}
                <div className="flex gap-2" data-id="element-2097">
                  <button onClick={() => setEventTypeFilter('all')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${eventTypeFilter === 'all' ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-2098">
                    Tutti
                  </button>
                  <button onClick={() => setEventTypeFilter('online')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${eventTypeFilter === 'online' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-2099">
                    💻 Online
                  </button>
                  <button onClick={() => setEventTypeFilter('in-person')} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${eventTypeFilter === 'in-person' ? 'bg-purple-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-2100">
                    📍 Dal vivo
                  </button>
                </div>
              </div>

              {/* Calendar Grid */}
              <div className="p-3 md:p-6" data-id="element-2101">
                {/* Day names */}
                <div className="grid grid-cols-7 gap-1 md:gap-2 mb-1 md:mb-2" data-id="element-2102">
                  {dayNames.map((day, index) => <div key={index} className="text-center text-xs md:text-sm font-medium text-gray-500 py-1 md:py-2" data-id="element-2103">
                      {day}
                    </div>)}
                </div>

                {/* Calendar days */}
                <div className="grid grid-cols-7 gap-1 md:gap-2" data-id="element-2104">
                  {emptyDays.map((_, index) => <div key={`empty-${index}`} className="aspect-square" data-id="element-2105"></div>)}
                  {days.map(day => {
                  const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
                  const events = getEventsForDate(date);
                  const isToday = date.toDateString() === new Date().toDateString();
                  const isSelected = selectedDate?.toDateString() === date.toDateString();
                  return <button key={day} onClick={() => setSelectedDate(date)} className={`aspect-square p-0.5 md:p-2 rounded-lg border transition-all ${isSelected ? 'border-green-600 bg-green-50' : isToday ? 'border-green-600 bg-white' : events.length > 0 ? 'border-gray-200 bg-white hover:border-green-600' : 'border-gray-100 bg-white hover:bg-gray-50'}`} data-id="element-2106">
                        <div className="flex flex-col items-center justify-center h-full" data-id="element-2107">
                          <span className={`text-xs md:text-sm font-medium ${isToday ? 'text-green-600' : 'text-gray-900'}`} data-id="element-2108">
                            {day}
                          </span>
                          {events.length > 0 && <div className="flex gap-0.5 mt-0.5" data-id="element-2109">
                              {events.slice(0, 2).map((event, idx) => <div key={idx} className={`w-1 h-1 md:w-1.5 md:h-1.5 rounded-full ${event.eventType === 'online' ? 'bg-blue-500' : 'bg-purple-500'}`} data-id="element-2110" />)}
                            </div>}
                        </div>
                      </button>;
                })}
                </div>
              </div>
            </div>

            {/* Selected Date Events */}
            {selectedDate && selectedDateEvents.length > 0 && <div className="mt-6 bg-white rounded-xl border border-gray-200 p-6" data-id="element-2111">
                <div className="flex items-center justify-between mb-4" data-id="element-2112">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-2113">
                    Eventi del {selectedDate.getDate()}{' '}
                    {monthNames[selectedDate.getMonth()]}
                  </h3>
                  <button onClick={() => setSelectedDate(null)} className="p-1 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-2114">
                    <XIcon size={20} className="text-gray-600" data-id="element-2115" />
                  </button>
                </div>
                <div className="space-y-3" data-id="element-2116">
                  {selectedDateEvents.map(event => <div key={event.id} className="p-4 border border-gray-200 rounded-lg hover:border-green-600 transition-colors" data-id="element-2117">
                      <div className="flex items-start justify-between" data-id="element-2118">
                        <div className="flex-1" data-id="element-2119">
                          <div className="flex items-center gap-2 mb-2" data-id="element-2120">
                            <span className={`px-2 py-0.5 rounded text-xs font-medium ${event.eventType === 'online' ? 'bg-blue-100 text-blue-700' : 'bg-purple-100 text-purple-700'}`} data-id="element-2121">
                              {event.eventType === 'online' ? '💻 Online' : '📍 Dal vivo'}
                            </span>
                            {event.type === 'admin' && <span className="px-2 py-0.5 bg-green-100 text-green-700 rounded text-xs font-medium" data-id="element-2122">
                                Greenback
                              </span>}
                          </div>
                          <h4 className="font-medium text-gray-900 mb-1" data-id="element-2123">
                            {event.title}
                          </h4>
                          <p className="text-sm text-gray-600 mb-2" data-id="element-2124">
                            {event.description}
                          </p>
                          <div className="flex items-center gap-4 text-xs text-gray-500" data-id="element-2125">
                            <span data-id="element-2126">
                              {new Date(event.date).toLocaleTimeString('it-IT', {
                          hour: '2-digit',
                          minute: '2-digit'
                        })}{' '}
                              -{' '}
                              {new Date(event.endTime).toLocaleTimeString('it-IT', {
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                            </span>
                            <span data-id="element-2127">Host: {event.host.name}</span>
                          </div>
                          {event.location && <p className="text-xs text-gray-500 mt-1" data-id="element-2128">
                              📍 {event.location}
                            </p>}
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>}
          </div>
        </main>
      </div>
    </div>;
};
export default CalendarPage;